import { EntityRepository, Repository } from "typeorm";
import { Rejections } from "./rejections.entity";

@EntityRepository(Rejections)
export class RejectionsRepository extends Repository<Rejections> {
    
}